import React, { useEffect, useState } from "react";
import { ConfirmButton } from "../../components/ConfirmButton";
import { notification } from "../../helpers/notification";
import {
    addEventBlacklists,
    deleteEventBlacklists,
    getEventBlacklists,
    updateEventBlacklists,
} from "../../services/eventBlacklistServices";

export const BlacklistList = () => {
    const [blacklistList, setBlacklistList] = useState([]);
    const [open, setOpen] = useState(false);
    const [editUniqueKey, setEditUniqueKey] = useState("");
    const [formData, setFormData] = useState({
        nameSurname: "",
        identityNumber: "",
        reason: "",
    });

    const onClose = () => {
        setOpen(false);
    };

    const resetForm = () => {
        setFormData({ nameSurname: "", identityNumber: "", reason: "" });
        setEditUniqueKey("");
    };

    const saveForm = (e) => {
        e.preventDefault();
        const form = { ...formData };

        if (!form.nameSurname || !form.identityNumber || !form.reason) {
            notification.error({ message: "Lütfen zorunlu alanları doldurunuz." });
            return;
        }

        if (editUniqueKey) {
            form.uniqueKey = editUniqueKey;
            updateEventBlacklists(form)
                .then(() => {
                    notification.success({ message: "Kayıt başarıyla güncellendi." });
                    resetForm();
                    setOpen(false);
                    getData();
                })
                .catch(() => {
                    notification.error({ message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz." });
                });
        } else {
            addEventBlacklists(form)
                .then(() => {
                    notification.success({ message: "Kayıt işlemi başarıyla yapıldı." });
                    resetForm();
                    setOpen(false);
                    getData();
                })
                .catch(() => {
                    notification.error({ message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz" });
                });
        }
    };

    const onDeleteConfirm = (uniqueKey) => {
        deleteEventBlacklists(uniqueKey)
            .then(() => {
                notification.success({ message: "Kayıt başarıyla silindi." });
                getData();
            })
            .catch(() => {
                notification.error({ message: "Bir hata oluştu tekrar deneyiniz" });
            });
    };

    const showEditPersonnelItem = (uniqueKey) => {
        const blacklist = blacklistList.find((f) => f.uniqueKey == uniqueKey);
        setFormData({
            nameSurname: blacklist.name,
            identityNumber: blacklist.userName,
            reason: "",
        });
        setEditUniqueKey(uniqueKey);
        setOpen(true);
    };

    const getData = () => {
        getEventBlacklists()
            .then((result) => {
                setBlacklistList(result.items);
            })
            .catch(() => {});
    };

    useEffect(() => {
        getData();
    }, []);

    function excelExport() {
        getEventBlacklists("excel")
            .then((result) => {
                const url = window.URL.createObjectURL(new Blob([result]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Kara Liste.xlsx");
                document.body.appendChild(link);
                link.click();
                return;
            })
            .catch(() => {});
    }

    return (
        <>
            <div className="max-w-7xl mx-auto px-4 py-6">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Kara Liste</h1>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => excelExport()}
                            className="inline-flex items-center gap-2 px-4 py-2 bg-green-500 text-white text-sm font-medium rounded-lg hover:bg-green-600 transition-colors"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            Excel&apos;e Aktar
                        </button>
                        <button
                            onClick={() => {
                                resetForm();
                                setOpen(true);
                            }}
                            className="inline-flex items-center gap-2 px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            Yeni Oluştur
                        </button>
                    </div>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left">
                            <thead className="text-xs text-gray-500 uppercase bg-gray-50 dark:bg-gray-800">
                                <tr>
                                    <th className="px-4 py-3">Adı Soyadı</th>
                                    <th className="px-4 py-3">TC Kimlik Numarası</th>
                                    <th className="px-4 py-3">Kara Liste Sebebi</th>
                                    <th className="px-4 py-3 text-right">İşlemler</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                                {blacklistList.map((item) => (
                                    <tr key={item.uniqueKey} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                                        <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{item.nameSurname}</td>
                                        <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{item.identityNumber}</td>
                                        <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{item.reason}</td>
                                        <td className="px-4 py-3 text-right">
                                            <ConfirmButton onConfirm={() => onDeleteConfirm(item.uniqueKey)} message="Kara listede bulunan kişiyi silmek istediğinizden emin misiniz?">
                                                <button
                                                    className="inline-flex items-center gap-1 px-3 py-1.5 bg-red-500 text-white text-xs font-medium rounded-lg hover:bg-red-600 transition-colors"
                                                >
                                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                    Sil
                                                </button>
                                            </ConfirmButton>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {open && (
                <>
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998]" onClick={onClose} />
                    <div className="fixed right-0 top-0 h-full w-full max-w-lg bg-white dark:bg-gray-900 z-[9999] shadow-2xl transition-transform">
                        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                {editUniqueKey ? "Kara Liste Güncelleme" : "Kara Listeye Yeni Kişi Ekle"}
                            </h3>
                            <button onClick={onClose} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-gray-500">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="p-6 overflow-y-auto">
                            <form onSubmit={saveForm} className="space-y-5">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Adı Soyadı</label>
                                    <input
                                        type="text"
                                        required
                                        value={formData.nameSurname}
                                        onChange={(e) => setFormData({ ...formData, nameSurname: e.target.value })}
                                        placeholder="Adı Soyadı"
                                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">TC Kimlik Numarası</label>
                                    <input
                                        type="text"
                                        required
                                        maxLength={11}
                                        value={formData.identityNumber}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                        }}
                                        onChange={(e) => setFormData({ ...formData, identityNumber: e.target.value })}
                                        placeholder="Kimlik Numarası"
                                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Kara Liste Sebebi</label>
                                    <input
                                        type="text"
                                        required
                                        value={formData.reason}
                                        onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
                                        placeholder="Kara Liste Sebebi"
                                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="inline-flex items-center gap-2 px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors"
                                >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                                    </svg>
                                    Kaydet
                                </button>
                            </form>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
